import type { Project } from "../types";

export const projects: Project[] = [
  {
    "id": "seger-fuar-tanitim-filmi",
    "slug": "seger-fuar-tanitim-filmi",
    "title": "Seger - \"Adımızı Bilmezsiniz Ama Sesimizi Bilirsiniz\" Yol Hikayeleri",
    "client": "SEGER Korna",
    "year": 2024,
    "shortDescription": "Dünya otomotiv devlerine ses veren Seger'in güvenilirlik ve teknoloji hikayesini duygu odaklı yol anlatımıyla yeniden konumlandıran reklam filmi serisi.",
    "fullDescription": "Farklı coğrafyalarda, zorlu yol koşullarında ve günlük yaşamın içinde Seger'in sesine odaklanan çok bölümlü sinematik reklam serisi üretildi. Akılda kalıcı slogan ve güçlü görsel ritim oluşturuldu.",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "SEGER"
      },
      {
        "role": "Ajans",
        "name": "YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Uluç Yemen Aslan"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera Asistanı",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Ses Teknisyeni",
        "name": "Yener Yalçın"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/seger-fuar-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=wXAec6qk63M",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/seger-fuar-tanitim-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Dünya otomotiv devlerine ses veren Seger'in güvenilirlik ve teknoloji hikayesini duygu odaklı yol anlatımıyla yeniden konumlandıran reklam filmi serisi.",
    "challenge": "Korna gibi teknik ve fonksiyonel bir otomotiv parçasını, araç kullanıcılarının en kritik anlardaki duygusal yol arkadaşı olarak konumlandırarak marka bilinirliğini yükseltmek.",
    "insight": "İnsanlar kornayı sadece bir parça olarak değil; tehlike anında uyaran, selam veren, sevinci paylaşan bir \"iletişim aracı\" olarak hisseder. Seger'in küresel gücü tam olarak bu sestir.",
    "solution": "Farklı coğrafyalarda, zorlu yol koşullarında ve günlük yaşamın içinde Seger'in sesine odaklanan çok bölümlü sinematik reklam serisi üretildi. Akılda kalıcı slogan ve güçlü görsel ritim oluşturuldu.",
    "productionCraft": "Arri Alexa Mini LF, car-rig kamera aparatları, özel tasarlanmış ses miksajı ve 5.1 surround ses tasarımı.",
    "metrics": [
      {
        "label": "Platform Erişimi",
        "value": "2.5M+ Görüntülenme"
      },
      {
        "label": "Çekim Lokasyonları",
        "value": "Bursa, İstanbul, Bolu"
      },
      {
        "label": "Bölüm Sayısı",
        "value": "3 Farklı Reklam Filmi"
      },
      {
        "label": "Etkileşim Artışı",
        "value": "%180 Sosyal Medya"
      }
    ],
    "deliverables": [
      "3x Reklam Filmi (45s, 30s, 15s)",
      "Dikey Reels/TikTok Formatları",
      "Uluslararası Otomotiv Fuarları Master"
    ]
  },
  {
    "id": "endocare-renewal-serisi-lansman-etkinlikleri-i-aftermovie",
    "slug": "endocare-renewal-serisi-lansman-etkinlikleri-i-aftermovie",
    "title": "Endocare Renewal Serisi - Türkiye Lansman Turu Aftermovie & Etkinlik Filmleri",
    "client": "Teka Estetik",
    "year": 2024,
    "shortDescription": "İstanbul, Ankara ve Antalya'daki seçkin dermatolog ve hekim buluşmalarının prestij ve enerjisini yansıtan çok şehirli etkinlik filmleri serisi.",
    "fullDescription": "3 şehirde eşzamanlı gezici prodüksiyon ekibiyle hekim röportajları, ürün deneyim anları ve workshop detayları sinematik gimbal hareketleriyle kayıt altına alındı.",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Teka Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      }
    ],
    "coverImage": "/project-covers/endocare-renewal-serisi-lansman-etkinlikleri-i-aftermovie.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=-aVKBzjCWvw",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/endocare-renewal-serisi-lansman-etkinlikleri-i-aftermovie/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "İstanbul, Ankara ve Antalya'daki seçkin dermatolog ve hekim buluşmalarının prestij ve enerjisini yansıtan çok şehirli etkinlik filmleri serisi.",
    "challenge": "3 farklı metropolde gerçekleşen bilimsel workshop ve gala lansmanlarının dinamizmini tıp ve estetik dünyasının seçkin vizyonuyla uyumlu şekilde belgelemek.",
    "insight": "Medikal estetik etkinliklerinde hem bilimsel ciddiyet hem de lüks atmosfer aynı karede hissettirilmelidir. Katılımcıların samimi deneyimleri markanın en güçlü referansıdır.",
    "solution": "3 şehirde eşzamanlı gezici prodüksiyon ekibiyle hekim röportajları, ürün deneyim anları ve workshop detayları sinematik gimbal hareketleriyle kayıt altına alındı.",
    "productionCraft": "Sony FX3 Full-Frame, Prime Lensler, Gezici LED Aydınlatma Seti, 48 Saatte Hızlı Kurgu ve Teslimat.",
    "metrics": [
      {
        "label": "Şehir Sayısı",
        "value": "3 Metropol (İst, Ank, Ant)"
      },
      {
        "label": "Katılımcı Hekim",
        "value": "450+ Uzman Doktor"
      },
      {
        "label": "Teslim Süresi",
        "value": "48 Saat İçinde Hızlı Kurgu"
      }
    ],
    "deliverables": [
      "Lansman Turu Aftermovie",
      "Şehir Bazlı 3x Kısa Video",
      "Instagram Hekim Röportaj Serisi"
    ]
  },
  {
    "id": "gokhan-haytoglu-vivacy-workshop",
    "slug": "gokhan-haytoglu-vivacy-workshop",
    "title": "Gökhan Haytoğlu - Vivacy Workshop",
    "client": "TEKA Estetik",
    "year": 2023,
    "shortDescription": "TEKA Estetik için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri TEKA Estetik Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Harutyun Arto Davulciyan, Enes Aktel Kurgu Bora Selimoğlu\n\nGökhan Haytoğlu: Kusursuz Güzellik İçin Estetik Bakış Açısı\n\nEstetik cerrahinin öncü ismi Dr. Gökhan Haytoğlu, kusursuz bir eğitim geçmişi ve uluslararası deneyimleriyle öne çıkıyor. Hatay doğumlu olan Dr. Haytoğlu, uzmanlık alanı olan plastik, rekonstrüktif ve estetik cerrahide başarılarını kanıtlamıştır. Ulusal ve uluslararası düzeyde yayınlanan makaleleri ve sunumlarıyla bilimsel katkıda bulunan Dr. Haytoğlu, sürekli olarak sektördeki yenilikleri takip ederek mükemmeliyeti hedeflemektedir\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TEKA Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Harutyun Arto Davulciyan, Enes Aktel"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/gokhan-haytoglu-vivacy-workshop.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=XG8aankRMK8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/gokhan-haytoglu-vivacy-workshop/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "TEKA Estetik için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "TEKA Estetik markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, TEKA Estetik kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "barut-fethiye-sensatori-tanitim-filmi",
    "slug": "barut-fethiye-sensatori-tanitim-filmi",
    "title": "Barut Hotels - Akdeniz'in Doğasında Lüks ve Huzurun Sinematik Portresi",
    "client": "Barut Hotels",
    "year": 2024,
    "shortDescription": "Akdeniz'in eşsiz doğasıyla Barut Hotels'in premium hizmet anlayışını birleştiren, uluslararası turizm pazarına yönelik büyüleyici tanıtım filmi.",
    "fullDescription": "Gündoğumu ve günbatımının sihirli saatlerinde çekilen sinematik hava ve kara planları, SPA ve gurme lezzetlerin makro dokunuşlarıyla zenginleştirildi.",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Barut Hotels"
      },
      {
        "role": "Ajans",
        "name": "Pozitif Film"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Fatih Uzgören"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Baret Borucuyan, Edvin Büyükloker"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/barut-fethiye-sensatori-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=DhpnzoSCbms",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/barut-fethiye-sensatori-tanitim-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 4 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Akdeniz'in eşsiz doğasıyla Barut Hotels'in premium hizmet anlayışını birleştiren, uluslararası turizm pazarına yönelik büyüleyici tanıtım filmi.",
    "challenge": "Otel tanıtım filmlerindeki standart şablonları aşarak; mekanın ruhunu, gastronomi zenginliğini ve kişiye özel huzur deneyimini izleyicide yaşatan bir film çekmek.",
    "insight": "Tatil arayışındaki lüks segment gezginler sadece oda manzarası değil, \"orada olmanın yaratacağı dinginlik hissini\" satın alır. Doğal ışık ve ses bu hissi taşır.",
    "solution": "Gündoğumu ve günbatımının sihirli saatlerinde çekilen sinematik hava ve kara planları, SPA ve gurme lezzetlerin makro dokunuşlarıyla zenginleştirildi.",
    "productionCraft": "Cinema Dronları (Apple ProRes RAW), RED 6K Kamera, Doğal Ambiyans Ses Tasarımı, Güneş Takip Çekim Planlaması.",
    "metrics": [
      {
        "label": "Çekim Lokasyonu",
        "value": "Antalya & Fethiye"
      },
      {
        "label": "Görüntü Kalitesi",
        "value": "4K DCI HDR"
      },
      {
        "label": "Uluslararası Gösterim",
        "value": "İngiltere, Almanya, BDT"
      }
    ],
    "deliverables": [
      "Sinematik Otel Filmi (2:30)",
      "Gastronomi, SPA ve Doğa Temalı 3x Teaser",
      "Instagram Reels Arşivi"
    ]
  },
  {
    "id": "pinar-protein-kurumsal-marka-proje-sunumu",
    "slug": "pinar-protein-kurumsal-marka-proje-sunumu",
    "title": "Pınar Protein - Kurumsal Marka & Proje Sunumu",
    "client": "Pınar Protein",
    "year": 2023,
    "shortDescription": "Pınar Protein için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri Pınar Protein Ajans Levent Kuğu Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nKurgu Harutyun Arto Davulciyan\n\nPınar Süt, 1973 yılında kurulan ve Türkiye’nin önde gelen markalarından biridir. Geniş ürün yelpazesiyle peynir, yoğurt, süt tozu ve daha fazlasını üreten Pınar, sağlıklı yaşamın önemini vurgulayan Pınar Protein ürünleriyle dikkat çekiyor. Besleyici ve protein açısından zengin ürünleriyle bilinen Pınar, lezzet ve kaliteyi bir araya getirerek tüketicilerine sağlıklı bir yaşam tarzı sunuyor.\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Pınar Protein"
      },
      {
        "role": "Ajans",
        "name": "Levent Kuğu"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Kurgu",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/pinar-protein-kurumsal-marka-proje-sunumu.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=6IC4x3jeCPo",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/pinar-protein-kurumsal-marka-proje-sunumu/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Pınar Protein için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "Pınar Protein markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, Pınar Protein kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "kristal-piksel-2024-web-sitesi",
    "slug": "kristal-piksel-2024-web-sitesi",
    "title": "Kristal Piksel 2024 - Web Sitesi",
    "client": "TOGED",
    "year": 2024,
    "shortDescription": "TOGED için canlı yayın alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Türkiye’de geliştirilen özgün fikrî mülkiyete sahip oyunları belirleme ve ödüllendirme amacıyla 2012 yılından beri düzenlenen ve Türkiye’nin ilk ve halen tek ödül töreni olan Kristal Piksel Video Oyun Ödülleri'nin 2024 resmi web platformu, başvuru ve jüri değerlendirme altyapısı WE24 Agency tarafından tasarlandı ve geliştirildi.",
    "categories": [
      "Canlı Yayın",
      "Web Siteleri",
      "Yazılım"
    ],
    "services": [
      "Canlı Yayın",
      "Web Siteleri",
      "Yazılım"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TOGED"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      }
    ],
    "coverImage": "/project-covers/kristal-piksel-2024-web-sitesi.webp",
    "gallery": [
      "/project-covers/kristal-piksel-2024-web-sitesi-g1.webp"
    ],
    "videoUrl": "",
    "videoProvider": null,
    "originalSourceUrl": "https://we24.com.tr/project/kristal-piksel-2024-web-sitesi/",
    "featured": false,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "TOGED için canlı yayın alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "TOGED markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, TOGED kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "kristal-piksel-2024-canli-yayin",
    "slug": "kristal-piksel-2024-canli-yayin",
    "title": "Kristal Piksel Video Oyun Ödülleri - Canlı Yayın & Ödül Töreni Rejisi",
    "client": "Kristal Piksel",
    "year": 2024,
    "shortDescription": "Türkiye'nin en prestijli oyun geliştirici ödüllerinde çok kameralı sahne rejisi, canlı interaktif grafikler ve sıfır kesintili YouTube/Twitch yayın yönetimi.",
    "fullDescription": "Sahne arkası, seyirci ve ödül kürsüsünü gören 5 kameralı reji sistemi kuruldu. Önceden hazırlanan dinamik motion grafik paketleri anlık olarak canlı yayına entegre edildi.",
    "categories": [
      "Canlı Yayın"
    ],
    "services": [
      "Canlı Yayın"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TOGED"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency & 24Creative"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency & 24Creative"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Baret Tercan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/kristal-piksel-2024-canli-yayin.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=SstAUX2mrAo",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/kristal-piksel-2024-canli-yayin/",
    "featured": false,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Türkiye'nin en prestijli oyun geliştirici ödüllerinde çok kameralı sahne rejisi, canlı interaktif grafikler ve sıfır kesintili YouTube/Twitch yayın yönetimi.",
    "challenge": "Canlı sahnede ödül anonsları, oyun fragmanları, canlı performanslar ve salon atmosferini eşzamanlı olarak harmanlayan 4 saatlik hatasız bir reji yönetimi gerçekleştirmek.",
    "insight": "Ödül törenlerinde ritim en ufak bir aksamada düşer. Canlı grafik giydirmelerinin kazanan anonslarıyla milisaniyelik senkronizasyonu televizyon kalitesinde bir deneyim yaratır.",
    "solution": "Sahne arkası, seyirci ve ödül kürsüsünü gören 5 kameralı reji sistemi kuruldu. Önceden hazırlanan dinamik motion grafik paketleri anlık olarak canlı yayına entegre edildi.",
    "productionCraft": "Blackmagic ATEM 2 M/E Constellation, PTZ kameralar, Kablosuz Gimbal Roaming Kamera, Dante dijital ses miksajı.",
    "metrics": [
      {
        "label": "Canlı Yayın Süresi",
        "value": "4 Saat Kesintisiz"
      },
      {
        "label": "Kamera Açısı",
        "value": "5 Bağımsız 4K Kamera"
      },
      {
        "label": "Toplam İzlenme",
        "value": "150K+"
      },
      {
        "label": "Ödül Kategorisi",
        "value": "18 Kategori"
      }
    ],
    "deliverables": [
      "Canlı Yayın Reji Prodüksiyonu",
      "Açılış ve Kategori Motion Grafik Paketleri",
      "Tören Sonrası 4K Aftermovie",
      "Kazananlar Özel Klipleri"
    ]
  },
  {
    "id": "24-creative-we24-agency-aerial-showreel-2018",
    "slug": "24-creative-we24-agency-aerial-showreel-2018",
    "title": "WE24 & 24Creative - Sinematik Hava Çekimleri & Drone Showreel",
    "client": "WE24 Agency & 24Creative",
    "year": 2018,
    "shortDescription": "24 Creative Aerial Showreel (2018) için showreel alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Hava Görüntüleri Harutyun Arto Davulciyan Kurgu Bora Selimoğlu\n\n24Creative: Prodüksiyon ve Post Prodüksiyon Hizmetleri\n\n24Creative, 2011 yılında kurulan ve iletişimde uzmanlaşmış bir prodüksiyon ve post-prodüksiyon ajansıdır. Görsel, işitsel, tasarımsal ve sanatsal projelerin üretim ve gelişim sürecini başarılı bir şekilde yönetmektedir. Müşteri memnuniyetine odaklanarak, samimi ve profesyonel hizmet anlayışıyla ihtiyaçları karşılamayı hedefler. Tecrübeli ekip ve yüzlerce marka ile çalışarak sektörde önemli bir konuma ulaşmıştır. 24Creative, her projeye heyecan ve tecrübesiyle yaklaşarak başarıya ulaşmayı amaçlar.\n\nDijital İletişim Ajansı",
    "categories": [
      "Showreel"
    ],
    "services": [],
    "credits": [
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/24-creative-we24-agency-aerial-showreel-2018.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=6q4TUMFkpTg",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/24-creative-we24-agency-aerial-showreel-2018/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "24 Creative Aerial Showreel (2018) için showreel alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "24 Creative Aerial Showreel (2018) markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, 24 Creative Aerial Showreel (2018) kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "dr-light-sosyal-medya-teaser-filmleri",
    "slug": "dr-light-sosyal-medya-teaser-filmleri",
    "title": "Dr-Light - Sosyal Medya Teaser Filmleri",
    "client": "Dr-Light",
    "year": 2023,
    "shortDescription": "Dr-Light için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri Dr-Light Ajans WE24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Artun Sağbazar, Harutyun Arto Davulciyan, Enes Aktel Kurgu Bora Selimoğlu\n\nDr-Light: Aydınlatma Sektörü’nde Lider\n\nEstetik tasarımların, nitelikli aydınlatmayla buluştuğu marka. 1950’lerde başlayan yolculuğumuzda, yarım asrı aşan deneyimimizi günümüz teknolojileriyle birleştirerek Dr-Light® markası altında aydınlatma sektöründe özgün tasarımlar sunuyoruz. Mimari projelerden konutlara kadar geniş bir yelpazede estetik ve şık aydınlatma çözümlerimizle imza atıyoruz. Şişli Showroom’umuzda sergilediğimiz koleksiyonlarımızla, profesyonel perakendecilik anlayışıyla son kullanıcıya ulaşıyoruz. Yerli üretim kalitesini uluslararası normlarda sağlayarak, tasarım ve kaliteyi herkesin erişebileceği bir noktada buluşturuyoruz.\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Dr-Light"
      },
      {
        "role": "Ajans",
        "name": "WE24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Harutyun Arto Davulciyan, Enes Aktel"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/dr-light-sosyal-medya-teaser-filmleri.webp",
    "gallery": [
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g1.webp",
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g2.webp",
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g3.webp",
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g4.webp",
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g5.webp"
    ],
    "videoUrl": "https://www.youtube.com/watch?v=3CoXmBylLHw",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/dr-light-sosyal-medya-teaser-filmleri/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Dr-Light için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "Dr-Light markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, Dr-Light kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "pinar-protein-umut-duygu-ile-training-lab",
    "slug": "pinar-protein-umut-duygu-ile-training-lab",
    "title": "Pınar Protein - Umut Duygu ile Training Lab",
    "client": "Pınar Protein",
    "year": 2023,
    "shortDescription": "Pınar Protein için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri Pınar Protein Ajans Levent Kuğu Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Levent Kuğu Kamera Levent Kuğu Post Prodüksiyon Bora Selimoğlu\n\nPınar Süt, 1973 yılında kurulan ve Türkiye’nin önde gelen markalarından biridir. Geniş ürün yelpazesiyle peynir, yoğurt, süt tozu ve daha fazlasını üreten Pınar, sağlıklı yaşamın önemini vurgulayan Pınar Protein ürünleriyle dikkat çekiyor. Besleyici ve protein açısından zengin ürünleriyle bilinen Pınar, lezzet ve kaliteyi bir araya getirerek tüketicilerine sağlıklı bir yaşam tarzı sunuyor.\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Pınar Protein"
      },
      {
        "role": "Ajans",
        "name": "Levent Kuğu"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Levent Kuğu"
      },
      {
        "role": "Kamera",
        "name": "Levent Kuğu"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/pinar-protein-umut-duygu-ile-training-lab.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=oqYo67olEuc",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/pinar-protein-umut-duygu-ile-training-lab/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Pınar Protein için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "Pınar Protein markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, Pınar Protein kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "e-konsey-tanitim-filmi",
    "slug": "e-konsey-tanitim-filmi",
    "title": "E-Konsey - Dijital Danışmanlık Platformu Tanıtım Filmi",
    "client": "E-Konsey",
    "year": 2023,
    "shortDescription": "E-Konsey için tanıtım filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri E-Konsey Ajans Contactplus+ Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Sanat Yönetmeni Aren Arda Kaya Yürütücü Yapımcı Fatih Uzgören Kamera Artun Sağbazar Kurgu Bora Selimoğlu Grafik Aren Arda Kaya Renk Düzenleme Harutyun Arto Davulciyan\n\nE-Konsey: Online Medikal Danışmanlık\n\nTürkiye’nin önde gelen medikal danışma platformu e-konsey, sağlık sorunlarınızı uzman doktorlarla online olarak paylaşmanızı sağlar. Tetkik raporlarınız güvenilir doktorlar tarafından ayrıntılı şekilde değerlendirilir ve size en uygun tedavi önerileri sunulur. Zamandan ve maddi açıdan tasarruf sağlayarak, kaliteli sağlık hizmetine kolayca ulaşmanızı sağlayan e-konsey, güvenli ve etkili bir danışmanlık deneyimi sunar.\n\nDijital İletişim Ajansı",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "E-Konsey"
      },
      {
        "role": "Ajans",
        "name": "Contactplus+"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Fatih Uzgören"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/e-konsey-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=iD4mOWtXQmc",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/e-konsey-tanitim-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "E-Konsey için tanıtım filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "E-Konsey markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, E-Konsey kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "fon-bulucu-tanitim-filmi",
    "slug": "fon-bulucu-tanitim-filmi",
    "title": "Fonbulucu - Türkiye'nin Kitle Fonlama Ekosistemine İlham Veren Marka Filmi",
    "client": "Fonbulucu",
    "year": 2024,
    "shortDescription": "Girişimcilerle yatırımcıları buluşturan Türkiye'nin öncü paya dayalı kitle fonlama platformunun vizyonunu ve güvenilirliğini anlatan dinamik tanıtım filmi.",
    "fullDescription": "Gerçek girişimcilerin ve yatırımcıların hikayelerinden esinlenen, stüdyo ve gerçek ofis sahnelerinin harmanlandığı enerjik bir görsel anlatı kurgulandı.",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "fonbulucu"
      },
      {
        "role": "Ajans",
        "name": "Contactplus+"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Fatih Uzgören"
      },
      {
        "role": "Kamera",
        "name": "Harutyun Arto Davulciyan, Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/fon-bulucu-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=ypMrPN5WpBI",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/fon-bulucu-tanitim-filmi/",
    "featured": false,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Girişimcilerle yatırımcıları buluşturan Türkiye'nin öncü paya dayalı kitle fonlama platformunun vizyonunu ve güvenilirliğini anlatan dinamik tanıtım filmi.",
    "challenge": "Fintek ve yatırım gibi karmaşık regülasyonlara sahip bir ekosistemi, hem ilk kez yatırım yapacak bireylere hem de yenilikçi girişimcilere sade ve ilham verici biçimde anlatmak.",
    "insight": "Yatırım kararları sadece mantıkla değil, \"geleceğin bir parçası olma\" arzusuyla alınır. Hikaye, fikirlerin nasıl gerçeğe dönüştüğüne odaklanmalıydı.",
    "solution": "Gerçek girişimcilerin ve yatırımcıların hikayelerinden esinlenen, stüdyo ve gerçek ofis sahnelerinin harmanlandığı enerjik bir görsel anlatı kurgulandı.",
    "productionCraft": "Blackmagic Pocket Cinema 6K, Gimbal hareketleri, dinamik tipografi ve motion infografik animasyonları.",
    "metrics": [
      {
        "label": "Kampanya Erişimi",
        "value": "1.2M+ İzlenme"
      },
      {
        "label": "Yatırımcı Kayıt Artışı",
        "value": "%45 Artış"
      },
      {
        "label": "Prodüksiyon Süresi",
        "value": "2 Hafta Uçtan Uca"
      }
    ],
    "deliverables": [
      "Ana Tanıtım Filmi (90s)",
      "Girişimci ve Yatırımcı Odaklı 2x Reklam",
      "Sosyal Medya Dikey Kurgular"
    ]
  },
  {
    "id": "launch-day-stream-mount-blade-ii-bannerlord-launch-day-stream-canli-yayin",
    "slug": "launch-day-stream-mount-blade-ii-bannerlord-launch-day-stream-canli-yayin",
    "title": "Mount & Blade II: Bannerlord - Global Lansmanda Kesintisiz Canlı Yayın & Çok Kameralı Reji",
    "client": "TaleWorlds Entertainment",
    "year": 2024,
    "shortDescription": "Global lansman gününde 500.000+ anlık izleyiciye ulaşan, 0 gecikme ve 0 drop frame ile kesintisiz yürütülen çok kameralı stüdyo canlı yayın prodüksiyonu.",
    "fullDescription": "24Creative ve WE24 ortaklığıyla, özel reji masası ve yüksek bant genişlikli yedekli fiber altyapı üzerinde stüdyo ortamı kuruldu. 6 bağımsız 4K kamera açısı, anlık oyun capture sistemleri ve canlı grafik giydirmeleri ile 8 saatlik kesintisiz bir küresel lansman şovu yönetildi.",
    "categories": [
      "Canlı Yayın"
    ],
    "services": [
      "Canlı Yayın"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Talesworld"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "24Creative & WE'24 Agency"
      },
      {
        "role": "Yapımcı",
        "name": "Tuğbek Ölek"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency & 24Creative"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Baret Tercan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/launch-day-stream-mount-blade-ii-bannerlord-launch-day-stream-canli-yayin.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=6HsrI92KsMQ",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/launch-day-stream-mount-blade-ii-bannerlord-launch-day-stream-canli-yayin/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Global lansman gününde 500.000+ anlık izleyiciye ulaşan, 0 gecikme ve 0 drop frame ile kesintisiz yürütülen çok kameralı stüdyo canlı yayın prodüksiyonu.",
    "challenge": "Dünyanın en çok beklenen RPG oyunlarından Mount & Blade II: Bannerlord'un küresel çıkış gününde; stüdyo konukları, canlı oyun içi deneyimler ve geliştirici röportajlarını dünya çapında yüz binlerce oyuncuya sıfır hata toleransıyla kesintisiz ulaştırmak.",
    "insight": "Küresel oyun topluluğu teknik aksaklıklara karşı son derece hassastır. Yayının bir televizyon standardında dinamik olması, reji masasının oyun içi anlık anlarla senkronize akması ve uluslararası yayıncı ağlarıyla eşzamanlı köprü kurulması gerekiyordu.",
    "solution": "24Creative ve WE24 ortaklığıyla, özel reji masası ve yüksek bant genişlikli yedekli fiber altyapı üzerinde stüdyo ortamı kuruldu. 6 bağımsız 4K kamera açısı, anlık oyun capture sistemleri ve canlı grafik giydirmeleri ile 8 saatlik kesintisiz bir küresel lansman şovu yönetildi.",
    "productionCraft": "1080p 60FPS kesintisiz canlı yayın encoder zinciri, Blackmagic ATEM prodüksiyon switcher sistemi, çok kameralı canlı yayın rejisi ve dinamik stüdyo aydınlatması.",
    "metrics": [
      {
        "label": "Yayın Kalitesi & Format",
        "value": "1080p 60FPS"
      },
      {
        "label": "Eşzamanlı İzleyici (Pik)",
        "value": "500K+"
      },
      {
        "label": "Yayın Süresi",
        "value": "8 Saat Kesintisiz"
      },
      {
        "label": "Yayın Platformları",
        "value": "Twitch, YouTube, Steam"
      }
    ],
    "deliverables": [
      "Canlı Yayın Rejisi",
      "Canlı Grafik Tasarımı",
      "8 Saatlik Full Master Kayıt",
      "YouTube VOD Paketleri",
      "Sosyal Medya Highlight Reels"
    ],
    "productionStandard": "1080p 60FPS"
  },
  {
    "id": "dr-light-kurumsal-tanitim-filmi",
    "slug": "dr-light-kurumsal-tanitim-filmi",
    "title": "Dr-Light - Mimari Aydınlatma Kurumsal Tanıtım Filmi",
    "client": "Dr-Light",
    "year": 2023,
    "shortDescription": "Lüks mimari ve dekoratif aydınlatma armatürleri markası Dr-Light için ışığın mekânsal estetiğini öne çıkaran kurumsal tanıtım filmi.",
    "fullDescription": "Müşteri: Dr-Light | Prodüksiyon & Post Prodüksiyon: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nKamera: Harutyun Arto Davulciyan, Artun Sağbazar\nKurgu: Bora Selimoğlu\n\nDr-Light: Işığın ve Tasarımın Buluştuğu Nokta\n\nLüks aydınlatma armatürleri, modern mimari tasarım konseptleri ve özel üretim projeleriyle sektörde öncü olan Dr-Light için hazırlanan kurumsal tanıtım filmi. Mekânların ruhunu değiştiren aydınlatma tasarımlarının zarafetini ve üretim kalitesini yüksek çözünürlüklü sinematik estetikle buluşturduk.",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Dr-Light"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/dr-light-kurumsal-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=8hRbpPgFXoo",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/dr-light-kurumsal-tanitim-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Dr-Light'ın üst segment mimarlık ve iç mekan projelerinde tercih edilen marka algısını güçlendiren sinematik kurumsal film.",
    "challenge": "Aydınlatma armatürlerindeki el işçiliği, pirinç detaylar ve mekânsal ışık dağılımını en etkileyici sinematik dille yansıtmak.",
    "insight": "Lüks aydınlatma ürünlerinde ışık-gölge kontrastı ve mekân atmosferi doğru aktarıldığında mimar ve tasarımcı güveni doğrudan artar.",
    "solution": "Geniş dinamik aralıklı sinema kameraları ve makro lenslerle ürünlerin malzeme kalitesi ve ambiyans gücü vurgulandı.",
    "productionCraft": "4K Yüksek Dinamik Aralıklı çekimler, cine prime lensler, DaVinci Resolve renk düzenlemesi.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ],
    "productionStandard": "4K Sinema Formatı"
  },
  {
    "id": "kadir-copdemir-ile-ogle-arasi-turkcell-bip",
    "slug": "kadir-copdemir-ile-ogle-arasi-turkcell-bip",
    "title": "Kadir Çöpdemir İle Öğle Arası - Turkcell BiP",
    "client": "4Play & Turkcell BiP",
    "year": 2023,
    "shortDescription": "4Play & Turkcell BiP için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri 4Play & Turkcell BiP Ajans Yemen Film Yapım I YFY Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Artun Sağbazar, Enes Aktel Kurgu Bora Selimoğlu\n\nTurkcell BiP: Yerli Teknolojilerle Geliştirilen Güvenli İletişim Platformu\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "4Play & Turkcell BiP"
      },
      {
        "role": "Ajans",
        "name": "Yemen Film Yapım I YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Enes Aktel"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/kadir-copdemir-ile-ogle-arasi-turkcell-bip.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=CLb9dR9DIIY",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/kadir-copdemir-ile-ogle-arasi-turkcell-bip/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 2 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "4Play & Turkcell BiP için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "4Play & Turkcell BiP markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, 4Play & Turkcell BiP kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "teka-estetik-youtube-kanal-yonetimi",
    "slug": "teka-estetik-youtube-kanal-yonetimi",
    "title": "Teka Estetik - YouTube Kanal Yönetimi",
    "client": "Teka Estetik",
    "year": 2024,
    "shortDescription": "Teka Estetik için youtube projeleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Teka Estetik bünyesindeki dünya markalarının (Heliocare, Endocare, VIVACY) medikal estetik ve dermatoloji alanındaki video içerik stratejisi, YouTube kanal yönetimi, video optimizasyonu, kapak tasarımları ve SEO operasyonları WE24 Agency tarafından yürütülmektedir.",
    "categories": [
      "YouTube Projeleri",
      "Sosyal Medya"
    ],
    "services": [
      "YouTube Projeleri",
      "Sosyal Medya"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Teka Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      }
    ],
    "coverImage": "/project-covers/teka-estetik-youtube-kanal-yonetimi.webp",
    "gallery": [
      "/project-covers/teka-estetik-youtube-kanal-yonetimi-g1.webp"
    ],
    "videoUrl": "",
    "videoProvider": null,
    "originalSourceUrl": "https://we24.com.tr/project/teka-estetik-youtube-kanal-yonetimi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Teka Estetik için youtube projeleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "Teka Estetik markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, Teka Estetik kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "her-dakika-bir-saat-eda-baba",
    "slug": "her-dakika-bir-saat-eda-baba",
    "title": "Eda Baba - Her Dakika Bir Saat Müzik Klibi",
    "client": "Eda Baba",
    "year": 2023,
    "shortDescription": "Türk bağımsız müziğinin naif ve güçlü sesi Eda Baba'nın 'Her Dakika Bir Saat' adlı eseri için hazırlanan duygu yüklü sinematik müzik klibi.",
    "fullDescription": "Sanatçı: Eda Baba | Prodüksiyon & Post Prodüksiyon: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nKurgu & Renk: Bora Selimoğlu, Harutyun Arto Davulciyan\n\nEda Baba: Her Dakika Bir Saat\n\nEda Baba'nın dingin ve naif vokaline eşlik eden sinematik atmosfer, görsel ritim ve duygusal renk paletiyle izleyiciye derin bir görsel-işitsel müzik deneyimi sunmaktadır.",
    "categories": [
      "Video Klipler"
    ],
    "services": [
      "Video Klipler"
    ],
    "credits": [
      {
        "role": "Sanatçı",
        "name": "Eda Baba"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/her-dakika-bir-saat-eda-baba.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=QWqAzH95j-o",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/her-dakika-bir-saat-eda-baba/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 3 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Eda Baba'nın dijital müzik platformlarındaki görsel kimliğini pekiştiren ve milyonlarca organik izlenmeye ulaşan müzik klibi.",
    "challenge": "Şarkının lirik duygusunu sadelik ve estetik bir sinematografiyle perdeye yansıtmak.",
    "insight": "Akustik ve naif müzik yapımlarında karmaşık efektler yerine doğal ışık ve samimi kamera açıları dinleyiciyle güçlü bağ kurar.",
    "solution": "Doğal ışık tonları ve 4K sinema kameralarıyla şarkının melodik akışına uyumlu ritmik bir kurgu yapıldı.",
    "productionCraft": "4K Sinema kamerası, doğal ışık tasarımı, DaVinci Resolve renk derecelendirme.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ],
    "productionStandard": "Sinematik 4K"
  },
  {
    "id": "turkiye-futbol-vakfi-odul-toreni-trailer",
    "slug": "turkiye-futbol-vakfi-odul-toreni-trailer",
    "title": "Türkiye Futbol Vakfı - Yılın Futbol Yıldızları Ödül Töreni Trailer",
    "client": "Türkiye Futbol Vakfı & Luys Media",
    "year": 2023,
    "shortDescription": "Luys Magazin - için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri Luys Magazin - Türkiye Futbol Vakfı Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Resim Seçici Bora Selimoğlu Kamera Artun Sağbazar, Enes Aktel Editor Bora Selimoğlu\n\nTürkiye Futbol Federasyonu Sosyal Yardım ve Dayanışma Vakfı\n\nTürkiye Futbol Federasyonu Sosyal Yardım ve Dayanışma Vakfı (TFF SYDV), futbolun gücünü toplumsal yardımla buluşturuyor. Profesyonel futbolculara yaşam sigortası, bakım ve yaşam merkezleri, sağlık hizmetleri ve maddi destek gibi sosyal yardımlar sunan vakıf, vize ve transfer işlemlerinden oluşturulan fonlarla yardıma muhtaç futbolcu ve ailelerine destek sağlıyor. Türkiye Futbol Vakfı, futbolun yanı sıra toplumsal sorumlulukları da önemseyen bir kuruluş olarak ön plana çıkıyor.\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Luys Magazin -"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Enes Aktel"
      }
    ],
    "coverImage": "/project-covers/turkiye-futbol-vakfi-odul-toreni-trailer.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=Xgv9O9SD3Og",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/turkiye-futbol-vakfi-odul-toreni-trailer/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Luys Magazin - için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "Luys Magazin - markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, Luys Magazin - kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "gazturman-gayan-50th-anniversary-event-trailer",
    "slug": "gazturman-gayan-50th-anniversary-event-trailer",
    "title": "Gazturman Gayan 50. Yıl Gala Etkinliği - Resmi Tanıtım Filmi",
    "client": "Gazturman Gayan & Luys Media",
    "year": 2023,
    "shortDescription": "Luys Magazin - Gazturman Gayan için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri Luys Magazin - Gazturman Gayan Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Reji Bora Selimoğlu Assistant Director/Operator Bora Selimoğlu Kamera Artun Sağbazar, Harutyun Arto Davulciyan, Enes Aktel, Baret Tercan Kurgu Bora Selimoğlu Editor Bora Selimoğlu\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Luys Magazin -"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Reji",
        "name": "Bora Selimoğlu"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Harutyun Arto Davulciyan, Enes Aktel, Baret Tercan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/gazturman-gayan-50th-anniversary-event-trailer.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=JEQAGR4mWKI",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/gazturman-gayan-50th-anniversary-event-trailer/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 3 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Luys Magazin - Gazturman Gayan için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "Luys Magazin - Gazturman Gayan markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, Luys Magazin - Gazturman Gayan kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "eskisehir-anadolu-universitesi-esitlik-kazansin-trailer",
    "slug": "eskisehir-anadolu-universitesi-esitlik-kazansin-trailer",
    "title": "Eskişehir Anadolu Üniversitesi - Eşitlik Kazansın Etkinlik Filmi",
    "client": "Anadolu Üniversitesi",
    "year": 2023,
    "shortDescription": "Anadolu Üniversitesi bünyesinde düzenlenen 'Eşitlik Kazansın' farkındalık projesinin dinamik ve ilham veren resmi tanıtım filmi.",
    "fullDescription": "Müşteri: Anadolu Üniversitesi | Prodüksiyon & Post: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nKamera: Harutyun Arto Davulciyan, Artun Sağbazar\nKurgu: Bora Selimoğlu\n\nEskişehir Anadolu Üniversitesi: Eşitlik Kazansın\n\nToplumsal cinsiyet eşitliği ve kapsayıcılık temalı üniversite projesinin enerjisini ve vizyonunu yansıtan sinematik etkinlik trailer filmi.",
    "categories": [
      "Etkinlik Filmleri",
      "Tanıtım Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri",
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Anadolu Üniversitesi"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/eskisehir-anadolu-universitesi-esitlik-kazansin-trailer.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=8_uWcG_4ZjQ",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/eskisehir-anadolu-universitesi-esitlik-kazansin-trailer/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Üniversite gençliği ve akademik camiada eşitlik bilincini yükselten dinamik ve etkileyici etkinlik tanıtımı.",
    "challenge": "Akademik ve toplumsal bir mesajı gençlerin ilgisini çekecek modern bir video diliyle harmanlamak.",
    "insight": "Hızlı kurgu ritmi, canlı renkler ve katılımcı enerjisi kurumsal sosyal sorumluluk filmlerini çok daha etkili kılar.",
    "solution": "Kampüs içi dinamik çekimler ve enerjik müzik senkronizasyonuyla güçlü bir etkinlik trailer'ı kurgulandı.",
    "productionCraft": "4K Çekim, gimbal stabilizasyonu, ritmik kurgu ve renk düzenlemesi.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ],
    "productionStandard": "4K Etkinlik Prodüksiyonu"
  },
  {
    "id": "fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi",
    "slug": "fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi",
    "title": "KUTES - Demirin Dönüşümünü Sinematik Bir Dille Anlatmak",
    "client": "Kutes Döküm",
    "year": 2025,
    "shortDescription": "Endüstriyel döküm teknolojisini sinematik estetikle buluşturarak global B2B pazarlarda marka prestijini ve kurumsal güvenilirliği zirveye taşıyan kurumsal tanıtım filmi.",
    "fullDescription": "Müşteri: KUTES | Ajans: Federation Agency | Prodüksiyon: WE'24 Agency & FUGS | Post Prodüksiyon: WE'24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nGörüntü Yönetmeni: Furkan Uyan\nCreative Director: Ali Algür\nSanat Yönetmeni: Aren Arda Kaya\nYürütücü Yapımcı: Ali Algür, Furkan Uyan\nReji: Andre Dinkiyan, Kami Balmumcu\nDrone Pilotu: Furkan Uyan\nKurgu: Bora Selimoğlu, Harutyun Arto Davulciyan\nRenk: Harutyun Arto Davulciyan, Furkan Uyan\n\nKUTES: Demirin Dönüşümünü Sinematik Bir Dille Anlatmak\n\nEndüstriyel döküm teknolojisini sinematik estetikle buluşturarak global B2B pazarlarda marka prestijini ve kurumsal güvenilirliği zirveye taşıyan kurumsal tanıtım filmi. 4K 60FPS ve 4K 120FPS yüksek hızlı sinematik çekimler, 4K profesyonel drone hava görüntüleri, makro lenslerle yakalanan erimiş demir detayları ve endüstriyel foley ses tasarımıyla fabrikanın üretim gücü en etkileyici şekilde beyaz perdeye aktarılmıştır.",
    "categories": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri",
      "Reklam Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri",
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "KUTES"
      },
      {
        "role": "Ajans",
        "name": "Federation Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency & FUGS"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Furkan Uyan"
      },
      {
        "role": "Creative Director",
        "name": "Ali Algür"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Ali Algür, Furkan Uyan"
      },
      {
        "role": "Reji",
        "name": "Andre Dinkiyan, Kami Balmumcu"
      },
      {
        "role": "Drone Pilotu",
        "name": "Furkan Uyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu, Harutyun Arto Davulciyan"
      },
      {
        "role": "Renk",
        "name": "Harutyun Arto Davulciyan, Furkan Uyan"
      }
    ],
    "coverImage": "/project-covers/fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=g1FVLDljoZ8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Endüstriyel döküm teknolojisini sinematik estetikle buluşturarak global B2B pazarlarda marka prestijini ve kurumsal güvenilirliği zirveye taşıyan kurumsal tanıtım filmi.",
    "challenge": "Ağır sanayi ve döküm sektörünün geleneksel soğuk anlatımını kırarak; yüksek teknolojiye, sürdürülebilirliğe ve mühendislik vizyonuna odaklanan modern bir küresel imaj filmi yaratmak.",
    "insight": "Endüstriyel B2B alıcılar sadece kapasite raporlarına değil, tesisin vizyonuna, disiplinine ve teknolojisine duyulan güvene göre karar verir. 1500 derecelik erimiş metalin enerjisi sinematik ışıkla birleştiğinde büyüleyici bir marka gücü oluşturur.",
    "solution": "4K 60FPS ve 4K 120FPS yüksek hızlı sinema kameraları, 4K profesyonel drone çekimleri, makro lenslerle yakalanan erimiş demir detayları ve endüstriyel ses tasarımı kullanılarak izleyiciyi fabrikanın kalbine çeken akıcı bir görsel anlatım kurgulandı.",
    "productionCraft": "4K 120FPS ve 4K 60FPS yüksek kare hızlı çekimler, 4K Drone hava görüntüleri, Türkçe, İngilizce ve Almanca çok dilli seslendirme, sinema lens setleri ve DaVinci Resolve endüstriyel renk tasarımı.",
    "metrics": [
      {
        "label": "Çekim Formatı",
        "value": "4K 60FPS & 120FPS"
      },
      {
        "label": "Hava Çekimleri",
        "value": "4K Drone Çekimi"
      },
      {
        "label": "Seslendirme & Dublaj",
        "value": "TR, EN, DE Dublaj"
      },
      {
        "label": "Çekim Lokasyonu",
        "value": "Tekirdağ / Çorlu"
      },
      {
        "label": "Prodüksiyon",
        "value": "WE24 & FUGS"
      }
    ],
    "deliverables": [
      "4K Sinematik Ana Film (3:30)",
      "4K Drone & Fabrika Çekim Master Kopyaları",
      "Türkçe, İngilizce ve Almanca Dublaj & Altyazı",
      "LinkedIn & B2B Sosyal Medya Video Kesitleri"
    ],
    "productionStandard": "4K 60FPS & 120FPS Sinematik Çekim"
  },
  {
    "id": "fabrika-tanitim-filmi-sapro-kurumsal-tanitim-filmi-we24-agency",
    "slug": "fabrika-tanitim-filmi-sapro-kurumsal-tanitim-filmi-we24-agency",
    "title": "Sapro - Türkiye'nin Islak Mendil Devine Global İhracat Vizyonu",
    "client": "Sapro Temizlik Ürünleri",
    "year": 2024,
    "shortDescription": "6 kıtada 60'tan fazla ülkeye ihracat yapan Avrupa lideri Sapro'nun Ar-Ge, hijyen ve devasa üretim gücünü anlatan çok dilli kurumsal tanıtım filmi.",
    "fullDescription": "Müşteri: Sapro Temizlik Ürünleri | Ajans: Contactplus+ | Prodüksiyon & Post: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nYürütücü Yapımcı: Fatih Uzgören\nKamera: Artun Sağbazar, Baret Borucuyan, Edvin Büyükloker\nKurgu: Bora Selimoğlu\n\nSapro: Türkiye'nin Islak Mendil Devine Global İhracat Vizyonu\n\n6 kıtada 60'tan fazla ülkeye ihracat yapan Avrupa lideri Sapro'nun Ar-Ge, hijyen ve devasa üretim gücünü anlatan çok dilli kurumsal tanıtım filmi. Tam otomasyon robotik hatlar, mikrobiyoloji laboratuvarları ve dev lojistik merkezinin 24 saatlik döngüsü sinematik ritimle kurgulandı. Uluslararası pazarlar için İngilizce seslendirme yapıldı.",
    "categories": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Sapro"
      },
      {
        "role": "Ajans",
        "name": "Contactplus+"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Fatih Uzgören"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Baret Borucuyan, Edvin Büyükloker"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/fabrika-tanitim-filmi-sapro-kurumsal-tanitim-filmi-we24-agency.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=nTrh1F-iw_Q",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/fabrika-tanitim-filmi-sapro-kurumsal-tanitim-filmi-we24-agency/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "6 kıtada 60'tan fazla ülkeye ihracat yapan Avrupa lideri Sapro'nun Ar-Ge, hijyen ve devasa üretim gücünü anlatan çok dilli kurumsal tanıtım filmi.",
    "challenge": "Avrupa ve Amerika'daki dev zincir marketlerin denetim standartlarına yanıt verebilecek seviyede hijyenik, teknolojik ve kapasite odaklı bir kurumsal film prodüksiyonu.",
    "insight": "Global perakende devleri için en kritik iki kriter; kesintisiz tedarik kapasitesi ve tavizsiz hijyen/Ar-Ge laboratuvarlarıdır. Film bu iki sütunu kanıtlarıyla sergilemeliydi.",
    "solution": "Tam otomasyon robotik hatlar, mikrobiyoloji laboratuvarları ve dev lojistik merkezinin 24 saatlik döngüsü sinematik ritimle kurgulandı. Uluslararası pazarlar için İngilizce seslendirme yapıldı.",
    "productionCraft": "Sony FX3 & FX6 Full Frame kamera gövdeleri, 2 Dil (TR, EN) seslendirme, gimbal ve temiz oda (cleanroom) özel koruma sistemleri.",
    "metrics": [
      {
        "label": "Kullanılan Kameralar",
        "value": "Sony FX3 & FX6 Full Frame"
      },
      {
        "label": "Dil Seçenekleri",
        "value": "2 Dil (TR, EN)"
      },
      {
        "label": "Çekim Alanı",
        "value": "45.000 m² Entegre Tesis"
      },
      {
        "label": "İhracat Pazarı",
        "value": "6 Kıtada 65+ Ülke"
      }
    ],
    "deliverables": [
      "Global Tanıtım Filmi (4K)",
      "Kısa Tanıtım Kurguları",
      "Ar-Ge ve Sürdürülebilirlik Modülleri",
      "Sosyal Medya Video Çıktıları"
    ],
    "productionStandard": "Sony FX3 & FX6 Full Frame"
  },
  {
    "id": "teka-estetik-web-sitesi",
    "slug": "teka-estetik-web-sitesi",
    "title": "Teka Estetik - Web Sitesi",
    "client": "Teka Estetik",
    "year": 2024,
    "shortDescription": "Teka Estetik için web siteleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "1970 yılında kurulan Teka A.Ş., kuruluşundan bu yana sağlık hizmetlerinde en kaliteli ürün ve hizmetleri sunmayı hedefleyen bir şirkettir. Türkiye'de ilaç, tıbbi cihaz, OTC ve dermokozmetik ürünlerde faaliyet gösteren Teka A.Ş., dünya çapındaki şirketlerle (Cantabria Labs, VIVACY) iş birliği yaparak Türk sağlık sektöründe önemli bir rol üstlenmiştir. Teka Estetik'in kurumsal ve ürün vitrini web platformu WE24 Agency tarafından uçtan uca tasarlanıp hayata geçirilmiştir.",
    "categories": [
      "Web Siteleri",
      "Yazılım"
    ],
    "services": [
      "Web Siteleri",
      "Yazılım"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Teka Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      }
    ],
    "coverImage": "/project-covers/teka-estetik-web-sitesi.webp",
    "gallery": [
      "/project-covers/teka-estetik-web-sitesi-g1.webp"
    ],
    "videoUrl": "",
    "videoProvider": null,
    "originalSourceUrl": "https://we24.com.tr/project/teka-estetik-web-sitesi/",
    "featured": true,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Teka Estetik için web siteleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "Teka Estetik markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, Teka Estetik kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "kristal-piksel-2025-canli-yayin",
    "slug": "kristal-piksel-2025-canli-yayin",
    "title": "Kristal Piksel 2025 - Canlı Yayın & Sahne Yönetimi",
    "client": "TOGED",
    "year": 2025,
    "shortDescription": "Kristal Piksel 2025 Ödül Töreni'nin kurumsal kimliği, logo tasarımı, dev LED ekran grafikleri, sahne-ışık-ses yönetimi ve çok kameralı canlı yayın rejisi.",
    "fullDescription": "Müşteri: TOGED | Ajans: WE’24 Agency | Prodüksiyon: 24Creative & WE'24 Agency | Post Prodüksiyon: WE’24 Agency & 24Creative\n\nEtkinlik & Yayın Yönetmeni: Harutyun Arto Davulciyan\nSanat Yönetmeni & LED Ekran Tasarımı: Aren Arda Kaya\nSahne, Işık, Ses & LED Ekran Yönetimi: Harutyun Arto Davulciyan & WE24 Ekibi\nKurumsal Kimlik, Logo ve Grafik Tasarım: Aren Arda Kaya & WE24 Tasarım Ekibi\nYapımcı: Tuğbek Ölek | Yürütücü Yapımcı & Canlı Yayın: Baret Tercan\nGimbal Operatörü: Mert Ünlü, Heros Agopyan | Kameraman: Sarkis Dolaş, Kami Balmumcu\nKurgu: Bora Selimoğlu, Baret Tercan | Fotoğrafçı: Kami Balmumcu | Sosyal Medya: Efi Kayıkçiyan\n\nKristal Piksel 2025: Türkiye’nin Oyun Oscarları\n\nTürkiye’de geliştirilen özgün fikrî mülkiyete sahip oyunları belirleme ve ödüllendirme amacıyla 2012 yılından beri düzenlenen Kristal Piksel Video Oyun Ödülleri'nin 12. töreni, WE24 Agency ve 24Creative ortaklığıyla 360 derece uçtan uca yönetildi. Törenin tüm kurumsal kimlik, logo ve grafik tasarımları, dev LED ekran içerikleri ve animasyonları, sahne akışı, ışık-ses tasarımı ve çok kameralı canlı yayın rejisi Harutyun Arto Davulciyan ve ekibimizce başarıyla hayata geçirildi.",
    "categories": [
      "Canlı Yayın",
      "Etkinlik Filmleri"
    ],
    "services": [
      "Canlı Yayın",
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TOGED"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "24Creative & WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency & 24Creative"
      },
      {
        "role": "Etkinlik & Canlı Yayın Yönetmeni",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni & LED Ekran Tasarımı",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Sahne, Işık, Ses & LED Ekran Yönetimi",
        "name": "Harutyun Arto Davulciyan & WE24 Ekibi"
      },
      {
        "role": "Kurumsal Kimlik, Logo ve Grafik Tasarım",
        "name": "Aren Arda Kaya & WE24 Tasarım Ekibi"
      },
      {
        "role": "Yapımcı",
        "name": "Tuğbek Ölek"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Baret Tercan"
      },
      {
        "role": "Canlı Yayın",
        "name": "Baret Tercan"
      },
      {
        "role": "Gimbal Operatörü",
        "name": "Mert Ünlü, Heros Agopyan"
      },
      {
        "role": "Kameraman",
        "name": "Sarkis Dolaş, Kami Balmumcu"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu, Baret Tercan"
      },
      {
        "role": "Fotoğrafçı",
        "name": "Kami Balmumcu"
      },
      {
        "role": "Sosyal Medya",
        "name": "Efi Kayıkçiyan"
      }
    ],
    "coverImage": "/project-covers/kristal-piksel-2025-canli-yayin.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=1254bUGsKA8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/kristal-piksel-2025-canli-yayin/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Kristal Piksel 2025 Ödül Töreni'nin tüm kurumsal kimlik, logo ve LED ekran tasarımlarının yanı sıra sahne, ışık, ses ve çok kameralı canlı yayın rejisinin 360° uçtan uca yönetildiği prestijli prodüksiyon.",
    "challenge": "Türkiye'nin en prestijli oyun ödül gecesinde salon içi binlerce katılımcı ve dijital yayın izleyicileri için sıfır gecikmeli, kusursuz görsel ritme sahip 360 derece canlı sahne ve yayın akışı oluşturmak.",
    "insight": "Canlı ödül törenlerinde sahne atmosferi, dinamik LED ekran grafikleri, senkronize ışık-ses tasarımı ve çok kameralı reji uyumu etkinliğin prestijini doğrudan belirler.",
    "solution": "Etkinliğin kurumsal kimlik ve logo tasarımlarından başlayarak dev sahne LED ekran içeriklerini ürettik. Eş zamanlı olarak sahne, ışık, ses ve çok kameralı canlı yayın reji yönetimini üstlenerek izleyicilere kusursuz ve dinamik bir ödül gecesi yaşattık.",
    "productionCraft": "Çok kameralı sinematik canlı yayın rejisi, anlık dinamik LED ekran motion tasarımları, profesyonel sahne ışık ve ses miksajı, DaVinci Resolve canlı renk kalibrasyonu.",
    "metrics": [
      {
        "label": "Yayın & Sahne Rejisi",
        "value": "360° Sahne, Işık, Ses, LED"
      },
      {
        "label": "Görsel Tasarım",
        "value": "Logo, Kurumsal Kimlik & LED"
      },
      {
        "label": "Prodüksiyon Ortaklığı",
        "value": "24Creative & WE24"
      },
      {
        "label": "Yayın Formatı",
        "value": "Çok Kameralı Canlı Yayın"
      }
    ],
    "deliverables": [
      "360° Sahne, Işık, LED & Ses Yönetimi",
      "Çok Kameralı Canlı Yayın Reji Yayını",
      "Etkinlik Kurumsal Kimliği, Logo & Grafik Tasarımları",
      "Özel Sahne LED Ekran Tasarımları & Hareketli Grafikler",
      "Sosyal Medya Kesitleri & Kapanış Kurgusu"
    ]
  },
  {
    "id": "dicle-tekstil-fabrika-tanitim-filmi-we24-agency-kurumsal-film",
    "slug": "dicle-tekstil-fabrika-tanitim-filmi-we24-agency-kurumsal-film",
    "title": "Dicle Tekstil - Entegre İplik & Dokuma Fabrikası Tanıtım Filmi",
    "client": "Dicle Tekstil",
    "year": 2025,
    "shortDescription": "Dicle Tekstil için tanıtım filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri Dicle Tekstil Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Sanat Yönetmeni Aren Arda Kaya Yürütücü Yapımcı Baret Tercan Reji Baret Borucuyan, Kami Balmumcu Drone Harutyun Arto Davulciyan Kurgu Bora Selimoğlu, Harutyun Arto Davulciyan Renk Harutyun Arto Davulciyan\n\n1975’te kurulan Dicle Tekstil, yıllar içinde Hindistan, Endonezya, Çin, Vietnam, Nepal, Tayland ve Pakistan’ı kapsayan geniş bir tedarik ağı geliştirdi. Yuvarlak örme, dokuma, triko ve dar dokuma üreticilerinin iplik ihtiyaçlarını stoktan karşılayarak sektörde konumlandı. Kaliteyi yönetmek ve sürdürülebilir üretimi kendi kontrolü altında yürütmek amacıyla Kütahya’da bir iplik fabrikası yatırımına gitti. Temmuz 2022’den beri faaliyette olan tesis, yüksek otomasyon seviyesine sahip olup 60.000 m² arazi üzerinde 45.000 m² kapalı alanda hizmet veriyor. Tesiste iplik çekim, elyaf boyama, büküm ve punta bölümleri bulunuyor; güneş enerji sistemi, ısı geri kazanımı ve atık su arıtma altyapılarıyla, sürdürülebilir elyaflardan üretim yaklaşımını destekliyor.\n\nWE’24 Agency olarak, Dicle Tekstil’in 1975’ten bugüne uzanan tedarik kabiliyetini ve Kütahya’daki entegre iplik üretim altyapısını modern, endüstriyel bir görsel dille anlattık. Filmde; stoktan hızlı tedarik yaklaşımı, yüksek otomasyonlu üretim hatları, elyaf boyama-büküm-punta süreçleri ve sürdürülebilirlik odaklı sistemler (GES, ısı geri kazanımı, atık su arıtma) öne çıkarıldı. Amaç, markanın kalite, hız ve sorumluluk ekseninde şekillenen üretim anlayışını yalın bir anlatım ve gerçek üretim görüntüleriyle portföyde net biçimde konumlandırmaktı.\n\nDijital İletişim Ajansı",
    "categories": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Dicle Tekstil"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Baret Tercan"
      },
      {
        "role": "Reji",
        "name": "Baret Borucuyan, Kami Balmumcu"
      },
      {
        "role": "Drone",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu, Harutyun Arto Davulciyan"
      },
      {
        "role": "Renk",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/dicle-tekstil-fabrika-tanitim-filmi-we24-agency-kurumsal-film.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=lOI0fPH4TD4",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/dicle-tekstil-fabrika-tanitim-filmi-we24-agency-kurumsal-film/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Dicle Tekstil için tanıtım filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "Dicle Tekstil markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, Dicle Tekstil kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "okm-seminer-istanbul-wow-hotel",
    "slug": "okm-seminer-istanbul-wow-hotel",
    "title": "OKM Medikal Teknoloji Semineri - İstanbul WOW Hotel",
    "client": "OKM",
    "year": 2023,
    "shortDescription": "OKM için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri OKM Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nGimbal Operatör/Kamera Artun Sağbazar Uygulayıcı Yapımcı Larissa Davulciyan Kurgu Bora Selimoğlu\n\nOKM: Alman Dedektör Markası\n\nDedektör endüstrisinde benzersiz bir fikirden trend belirleyiciye: Bir zamanlar ev garajında hobi olarak başlayan OKM, bugün dünya çapında başarılı bir şirkettir.\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "OKM"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/okm-seminer-istanbul-wow-hotel.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=g2wiJx5ltIU",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/okm-seminer-istanbul-wow-hotel/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "OKM için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "OKM markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, OKM kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "hayatta-kalma-savasi-nepal-trt-belgesel",
    "slug": "hayatta-kalma-savasi-nepal-trt-belgesel",
    "title": "Hayatta Kalma Savaşı: Nepal - TRT Belgesel İçin Zorlu Coğrafyalarda Sinematik Hikaye Anlatımı",
    "client": "TRT Belgesel",
    "year": 2023,
    "shortDescription": "Himalayalar'ın sarp eteklerinde zorlu şartlarda hayata tutunan insanların öyküsünü uluslararası belgesel standartlarında ekrana taşıyan televizyon yapımı.",
    "fullDescription": "Hafifletilmiş yüksek kaliteli sinema kamera kitleri ve bağımsız ses kayıt sistemleri ile 3000+ metre irtifada 14 günlük zorlu bir keşif ve prodüksiyon süreci yürütüldü.",
    "categories": [
      "Belgeseller"
    ],
    "services": [
      "Belgeseller"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TRT Belgesel"
      },
      {
        "role": "Ajans",
        "name": "Yemen Film Yapım I YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Yapımcı",
        "name": "Uluç Yemen Aslan"
      },
      {
        "role": "Yönetmen",
        "name": "Abdurrahman Houssain"
      }
    ],
    "coverImage": "/project-covers/hayatta-kalma-savasi-nepal-trt-belgesel.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=3q_a18ykzjE",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/hayatta-kalma-savasi-nepal-trt-belgesel/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Himalayalar'ın sarp eteklerinde zorlu şartlarda hayata tutunan insanların öyküsünü uluslararası belgesel standartlarında ekrana taşıyan televizyon yapımı.",
    "challenge": "Aşırı irtifa, zorlu hava koşulları ve lojistik imkansızlıklar altında günlerce süren çekimlerde yüksek sinematik standarttan ve insani samimiyetten ödün vermemek.",
    "insight": "Belgeselin gücü kameranın görünmez olmasından gelir. Yöre halkıyla kurulan samimi bağ, Nepal dağlarındaki yaşam mücadelesini en sahici haliyle yansıtır.",
    "solution": "Hafifletilmiş yüksek kaliteli sinema kamera kitleri ve bağımsız ses kayıt sistemleri ile 3000+ metre irtifada 14 günlük zorlu bir keşif ve prodüksiyon süreci yürütüldü.",
    "productionCraft": "Sony FX6 ve FX3 hafif seyahat kitleri, rüzgar korumalı shotgun mikrofonlar, zorlu arazi dron çekimleri.",
    "metrics": [
      {
        "label": "Çekim İrtifası",
        "value": "3.500+ Metre"
      },
      {
        "label": "Çekim Süresi",
        "value": "14 Gün Nepal Dağları"
      },
      {
        "label": "Yayın Kanalı",
        "value": "TRT Belgesel Prime Time"
      },
      {
        "label": "TV Reyting Sıralaması",
        "value": "Günün En Çok İzlenen Belgeseli"
      }
    ],
    "deliverables": [
      "45 Dakikalık TV Belgesel Master",
      "Uluslararası Belgesel Festivalleri Kurgusu",
      "Sosyal Medya Teaser Paketi"
    ]
  },
  {
    "id": "arma-kontrol-reklam-filmi",
    "slug": "arma-kontrol-reklam-filmi",
    "title": "Arma Kontrol - Yüksek Güvenlik Bariyer Sistemleri Reklam Filmi",
    "client": "Arma Kontrol",
    "year": 2024,
    "shortDescription": "Uluslararası askeri ve sivil tesislerde kullanılan yüksek güvenlikli bariyerlerin dayanıklılık ve mühendislik üstünlüğünü kanıtlayan sinematik reklam filmi.",
    "fullDescription": "Aksiyon filmi ritminde kurgulanan sahneler, gece ışıklandırması ve çarpışma anlarının detaylı ağır çekimleri ile markanın \"tavizsiz güvenlik\" iddiası görselleştirildi.",
    "categories": [
      "Reklam Filmleri"
    ],
    "services": [
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Arma Kontrol"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/arma-kontrol-reklam-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=ieAguHreNys",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/arma-kontrol-reklam-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Uluslararası askeri ve sivil tesislerde kullanılan yüksek güvenlikli bariyerlerin dayanıklılık ve mühendislik üstünlüğünü kanıtlayan sinematik reklam filmi.",
    "challenge": "Çarpışma testlerinden (crash test) başarıyla geçen anti-terör bariyer sistemlerinin sağlamlığını hem estetik hem de etkileyici bir aksiyon diliyle aktarmak.",
    "insight": "Güvenlik sektöründe alıcılar söze değil doğrudan \"dayanıklılık kanıtına\" bakar. Ağır vasıta çarpma testlerinin yüksek hızlı kameralarla belgelenmesi en ikna edici satıştır.",
    "solution": "Aksiyon filmi ritminde kurgulanan sahneler, gece ışıklandırması ve çarpışma anlarının detaylı ağır çekimleri ile markanın \"tavizsiz güvenlik\" iddiası görselleştirildi.",
    "productionCraft": "6K RAW ve 4K 50FPS sinematik ana çekimler, çarpışma testleri için 4K RAW 240fps yüksek hızlı kamera, Ronin 2 gimbal ve sinematik ses tasarımı.",
    "metrics": [
      {
        "label": "Çekim Formatı",
        "value": "6K RAW & 4K 50FPS"
      },
      {
        "label": "Yüksek Hızlı Test Çekimi",
        "value": "4K RAW 240fps"
      },
      {
        "label": "İhracat Yapılan Ülke",
        "value": "55+ Ülke"
      },
      {
        "label": "Çekim Lokasyonu",
        "value": "Test Sahası & Fabrika"
      }
    ],
    "deliverables": [
      "Ana Reklam Filmi (60s)",
      "Test Kanıtı Kısa Kurguları",
      "Uluslararası Savunma Sanayii Fuar Versiyonları"
    ],
    "productionStandard": "6K RAW ve 4K 50FPS"
  },
  {
    "id": "cagla-gursoy-ile-tarzim-cepte-turkcell-bip",
    "slug": "cagla-gursoy-ile-tarzim-cepte-turkcell-bip",
    "title": "Çağla Gürsoy ile Tarzım Cepte - Turkcell BiP",
    "client": "4Play & Turkcell BiP",
    "year": 2023,
    "shortDescription": "4Play & Turkcell BiP için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri 4Play & Turkcell BiP Ajans CYemen Film Yapım I YFY Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Artun Sağbazar Kurgu Bora Selimoğlu\n\nTurkcell BiP: Yerli Teknolojilerle Geliştirilen Güvenli İletişim Platformu\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "4Play & Turkcell BiP"
      },
      {
        "role": "Ajans",
        "name": "Yemen Film Yapım I YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/cagla-gursoy-ile-tarzim-cepte-turkcell-bip.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=ZQdnzvvmpcw",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/cagla-gursoy-ile-tarzim-cepte-turkcell-bip/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 2 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "4Play & Turkcell BiP için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "4Play & Turkcell BiP markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, 4Play & Turkcell BiP kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "seger-korna-montaji-i-nasil-yapilir-serisi",
    "slug": "seger-korna-montaji-i-nasil-yapilir-serisi",
    "title": "Seger - Korna Montajı I \"Nasıl Yapılır?\" Serisi",
    "client": "SEGER",
    "year": 2024,
    "shortDescription": "SEGER için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri SEGER Ajans YFY Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Uluç Yemen Aslan Görüntü Yönetmeni Harutyun Arto Davulciyan Kamera Asistanı Artun Sağbazar Ses Teknisyeni Yener Yalçın Kurgu Bora Selimoğlu\n\nSeger: Adımızı Bilmezsiniz Ama Sesimizi Bilirsiniz\n\nWE24 Agency olarak Seger’in 10 farklı korna serisi için hazırladığımız ‘Nasıl Yapılır’ videoları, kullanıcıların ve yetkili bayilerin kolay ve doğru montaj yapabilmeleri için adım adım rehberlik sunmaktadır. Bu videolar, Seger’in ürün kalitesi ve müşteri odaklı yaklaşımını destekleyerek, pratik ve anlaşılır bir şekilde montaj süreçlerini anlatmaktadır.\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "SEGER"
      },
      {
        "role": "Ajans",
        "name": "YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Uluç Yemen Aslan"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera Asistanı",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Ses Teknisyeni",
        "name": "Yener Yalçın"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/seger-korna-montaji-i-nasil-yapilir-serisi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=fy1mPRC-fcg",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/seger-korna-montaji-i-nasil-yapilir-serisi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "SEGER için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "SEGER markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, SEGER kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "seger-fuar-tanitim-filmi-2",
    "slug": "seger-fuar-tanitim-filmi-2",
    "title": "Seger - Fuar Tanıtım Filmi",
    "client": "SEGER",
    "year": 2024,
    "shortDescription": "SEGER için tanıtım filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri SEGER Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nSeslendirme Harutyun Arto Davulciyan Kurgu Bora Selimoğlu\n\nSeger: Adımızı Bilmezsiniz Ama Sesimizi Bilirsiniz\n\nWE24 Agency olarak Seger için hazırladığımız fuar tanıtım filmi, firmanın global başarısını, otomotiv sektöründeki yenilikçi üretim gücünü ve toplumsal cinsiyet eşitliğine verdiği desteği vurgulamaktadır. Seger, yüksek kaliteli kornaları ve aydınlatma çözümleriyle Türkiye’yi dünyada gururla temsil etmektedir.\n\nDijital İletişim Ajansı",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "SEGER"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/seger-fuar-tanitim-filmi-2.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=gX5vHthB8vU",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/seger-fuar-tanitim-filmi-2/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "SEGER için tanıtım filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "SEGER markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, SEGER kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "tanitim-filmi-3b-fab-we24-agency-fabrika-reklam-filmi",
    "slug": "tanitim-filmi-3b-fab-we24-agency-fabrika-reklam-filmi",
    "title": "3B FAB - 3D Yazıcı & Endüstriyel Üretim Fabrika Tanıtım Filmi",
    "client": "3B FAB",
    "year": 2025,
    "shortDescription": "3B FAB için tanıtım filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri 3B FAB Ajans FUGS Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Görüntü Yönetmeni Furkan Uyan Sanat Yönetmeni Aren Arda Kaya Yürütücü Yapımcı Furkan Uyan Kamera Andre Dinkiyan, Harutyun Arto Davulciyan Kurgu Bora Selimoğlu, Harutyun Arto Davulciyan Renk Harutyun Arto Davulciyan\n\n3B FAB 2013’te kurulan NovaFab, üretime yönelik 3D yazıcılar ve fotopolimer reçineler geliştirip üretmektedir. NovaFab’ın ekosistemi; CAD/CAM tasarım, profesyonel 3D yazıcılar ve “Design Market” üzerinden binlerce baskıya hazır ürünü kapsar. Miami, Amsterdam ve Dubai’nin de aralarında bulunduğu 7 lokasyonda ofisleri bulunan şirketin yazıcıları ve malzemeleri, bayileri aracılığıyla 60’tan fazla ülkede binlerce profesyonel tarafından kullanılmaktadır. 3BFAB, mücevher odaklı çözümlerini Novafab, dişçilik çözümlerini Dentafab ve fotopolimer reçinelerini PowerResins markalarıyla konumlandırır.\n\nWE’24 Agency olarak, 3B FAB’in (NovaFab) dijital üretim ekosistemini; CAD/CAM tasarım, profesyonel 3D yazıcılar ve fotopolimer reçine çözümleri ekseninde, modern ve teknolojik bir anlatımla görünür kılmayı hedefledik. Yaratıcı ve planlama süreci FUGS tarafından yönetilen projede; markanın mücevher ve dişçilik profesyonellerine sunduğu hız, kolaylık ve maliyet avantajlarını, süreçlerden kesitler ve ürün odaklı görüntülerle bir araya getirdik. Küresel ölçekteki erişimi ve kullanıcı geri bildirimlerine dayalı ürün geliştirme yaklaşımını öne çıkaran bu film, 3B FAB’in üretimde güvenilir ve bütünleşik bir çözüm sunma iddiasını net ve tutarlı bir görsel dil ile ifade eder.\n\nDijital İletişim Ajansı",
    "categories": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri",
      "Reklam Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri",
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "3B FAB"
      },
      {
        "role": "Ajans",
        "name": "FUGS"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Furkan Uyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Furkan Uyan"
      },
      {
        "role": "Kamera",
        "name": "Andre Dinkiyan, Harutyun Arto Davulciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu, Harutyun Arto Davulciyan"
      },
      {
        "role": "Renk",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/tanitim-filmi-3b-fab-we24-agency-fabrika-reklam-filmi.webp",
    "gallery": [],
    "videoUrl": "https://youtu.be/kaI5uuNQvJI",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/tanitim-filmi-3b-fab-we24-agency-fabrika-reklam-filmi/",
    "featured": false,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "3B FAB için tanıtım filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "3B FAB markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, 3B FAB kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "1351",
    "slug": "1351",
    "title": "Alfa Solar - Güneş Paneli Reklam Filmi & Halka Arz Kampanyası",
    "client": "Alfa Solar",
    "year": 2023,
    "shortDescription": "Alfa Solar'ın halka arz sürecinde TV ve dijital mecralarda geniş kitlelere ulaşan, özgün müziği WE24 stüdyosunda bestelenen ve rekor taleple sonuçlanan reklam filmi.",
    "fullDescription": "Müşteri: Alfa Solar | Ajans: Levent Kuğu | Prodüksiyon & Post Prodüksiyon: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nÖzgün Müzik: Avedis Özdemir (WE24 Stüdyo Beste & Kayıt)\nYürütücü Yapımcı: Levent Kuğu\nReji: Andre Dinkiyan, Larissa Davulciyan\nKurgu: Bora Selimoğlu | Oyuncu Set Ekibi: Umut Yıldırım\n\nAlfa Solar: Türkiye'nin Önde Gelen Güneş Paneli Üreticisi\n\nAlfa Solar markasının halka arz sürecinde yatırımcı güveni oluşturmak ve marka liderliğini pekiştirmek amacıyla hazırlanan reklam filmi, ulusal televizyon kanallarında ve dijital mecralarda uzun dönem yayında kalmıştır. Reklam filminin özgün müziği, ajansımız müzisyeni Avedis Özdemir tarafından özel olarak bestelenmiş ve stüdyomuzda canlı enstrümanlarla kaydedilmiştir. Proje, hem ulusal TV yayın standartlarına hem de dijital/sosyal medya formatlarına uygun master kopyalarla teslim edilmiş; halka arz sürecinde Türkiye genelinde rekor katılım ve tarihi bir başarı elde edilmiştir.",
    "categories": [
      "Reklam Filmleri"
    ],
    "services": [
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Alfa Solar"
      },
      {
        "role": "Ajans",
        "name": "Levent Kuğu"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Özgün Müzik",
        "name": "Avedis Özdemir (WE24 Stüdyo)"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Levent Kuğu"
      },
      {
        "role": "Reji",
        "name": "Andre Dinkiyan, Larissa Davulciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      },
      {
        "role": "Kamera Asistanı",
        "name": "Umut Yıldırım"
      }
    ],
    "coverImage": "/project-covers/1351.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=BOE_Of1YRrg",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/?p=1351",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Ulusal TV kanallarında ve dijitalde uzun dönem yayınlanarak Alfa Solar halka arzında tarihi rekor katılım sağlayan sinematik reklam kampanyası.",
    "challenge": "Yenilenebilir enerji teknolojisinin geleceğini ve sanayi gücünü hem bireysel yatırımcılara hem kurumsal kitleye hitap eden güven verici bir sinematik dille kurgulamak.",
    "insight": "Halka arz kampanyalarında marka güveni ve gelecek vizyonu, özel bestelenmiş özgün müzik ve yüksek prodüksiyon kalitesiyle birleştiğinde yatırımcı kararını doğrudan tetikler.",
    "solution": "WE24 yönetmenliği ve sanat yönetmenliğinde, Avedis Özdemir'in bestelediği stüdyo kayıtlı özgün müzik eşliğinde TV ve sosyal medya için eksiksiz yayın master'ları üretildi.",
    "productionCraft": "4K Sinema kameraları, özel beste & stüdyo ses miksajı, DaVinci Resolve renk düzenlemesi, TV ve dijital için çok formatlı master teslimatı.",
    "metrics": [
      {
        "label": "Halka Arz Sonucu",
        "value": "Tarihi Rekor Katılım"
      },
      {
        "label": "Yayın Mecraları",
        "value": "Ulusal TV & Dijital"
      },
      {
        "label": "Özgün Müzik",
        "value": "Avedis Özdemir (WE24)"
      },
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon",
        "value": "Sinema Formatı"
      }
    ],
    "deliverables": [
      "Ulusal TV Reklam Master Kopyaları",
      "Dijital & Sosyal Medya Çıktıları (16:9, 9:16)",
      "Özel Bestelenmiş Orijinal Reklam Müziği",
      "Yüksek Çözünürlüklü Basın & Medya Görselleri"
    ]
  },
  {
    "id": "heliocare-yaza-merhaba-partisi-teaser",
    "slug": "heliocare-yaza-merhaba-partisi-teaser",
    "title": "Heliocare Yaza Merhaba Partisi - Teaser",
    "client": "TEKA Estetik - Heliocare",
    "year": 2023,
    "shortDescription": "TEKA Estetik - Heliocare için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri TEKA Estetik - Heliocare Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Uygulayıcı Yapımcı Larissa Davulciyan Kamera Enes Aktel Fotoğraf Kami Garbis Balmumciyan Kurgu Bora Selimoğlu\n\nTEKA Estetik: Lider Dermokozmetik Ürünler Distribütorü\n\nTürkiye’nin önde gelen sağlık markalarından biri olan TEKA, ilaç, tıbbi cihaz, OTC ve dermokozmetik ürünlerinde kalite ve hizmet odaklı bir hizmet sunmaktadır. Oftalmoloji, dermatoloji, medikal estetik ve jinekoloji alanlarında faaliyet gösteren TEKA, dünya şirketleriyle iş birlikleri yaparak sağlık sektöründe önemli bir konumda yer almaktadır. HELIOCARE ve VIVACY gibi markaları bünyesinde barındıran TEKA, yenilikçi ve etkili anti-aging çözümleriyle sağlık profesyonelleri ve hastalar için hedeflerine odaklanmaktadır.\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TEKA Estetik - Heliocare"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Enes Aktel"
      },
      {
        "role": "Fotoğraf",
        "name": "Kami Garbis Balmumciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/heliocare-yaza-merhaba-partisi-teaser.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=S5_0X2sAbIE",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/heliocare-yaza-merhaba-partisi-teaser/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "TEKA Estetik - Heliocare için etkinlik filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "TEKA Estetik - Heliocare markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, TEKA Estetik - Heliocare kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "vw-kristal-elma-official-aftermovie",
    "slug": "vw-kristal-elma-official-aftermovie",
    "title": "Volkswagen - Kristal Elma Yaratıcılık Festivali Aftermovie & Etkinlik Filmi",
    "client": "Volkswagen Türkiye",
    "year": 2023,
    "shortDescription": "Türkiye'nin en prestijli reklam ve yaratıcılık festivali Kristal Elma'da Volkswagen deneyim alanının enerjisini yakalayan dinamik aftermovie filmi.",
    "fullDescription": "Müşteri: Volkswagen Türkiye | Prodüksiyon & Post: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nKurgu & Renk: Bora Selimoğlu, Harutyun Arto Davulciyan\n\nVolkswagen x Kristal Elma Festivali\n\nReklam ve pazarlama dünyasının kalbinin attığı Kristal Elma Yaratıcılık Festivali'nde, Volkswagen standının ve marka aktivitelerinin heyecanını hızlı tempolu, dinamik ve sinematik bir kurgu diliyle ölümsüzleştirdik.",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Volkswagen Türkiye"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/vw-kristal-elma-official-aftermovie.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=8kObhCXcp38",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/vw-kristal-elma-official-aftermovie/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Volkswagen'in yaratıcı endüstrilerdeki inovatif marka imajını ve festival etkileşimini belgeleyen prestijli etkinlik filmi.",
    "challenge": "Kristal Elma'daki yoğun festival temposunu ve Volkswagen'in interaktif deneyim alanlarını kesintisiz bir ritimle aktarmak.",
    "insight": "B2B ve yaratıcı sektör etkinliklerinde hızlı kurgu, katılımcı tepkileri ve marka kimliğinin dengeli sunumu yüksek izlenme sağlar.",
    "solution": "Çok açılı gimbal çekimleri ve festival ambiyansını yansıtan dinamik ses kurgusu ile proje tamamlandı.",
    "productionCraft": "4K Gimbal çekimleri, hızlı ritimli post-prodüksiyon kurgusu, renk derecelendirme.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ],
    "productionStandard": "4K Aftermovie Prodüksiyonu"
  },
  {
    "id": "nasil-dustum-bu-derde-guney-marlen",
    "slug": "nasil-dustum-bu-derde-guney-marlen",
    "title": "Güney Marlen - Nasıl Düştüm Bu Derde Müzik Klibi",
    "client": "Güney Marlen",
    "year": 2023,
    "shortDescription": "Güney Marlen'in kendine has melodik ve lirik tarzını yansıtan 'Nasıl Düştüm Bu Derde' şarkısı için hazırlanan atmosferik sinematik klip.",
    "fullDescription": "Sanatçı: Güney Marlen | Prodüksiyon & Post: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nKurgu & Renk: Bora Selimoğlu, Harutyun Arto Davulciyan\n\nGüney Marlen: Nasıl Düştüm Bu Derde\n\nŞehir hayatının hüznünü ve arayışını anlatan şarkıya özel görsel metaforlar, sinematik ışıklandırma ve sıcak renk derecelendirmesiyle hayat verildi.",
    "categories": [
      "Video Klipler"
    ],
    "services": [
      "Video Klipler"
    ],
    "credits": [
      {
        "role": "Sanatçı",
        "name": "Güney Marlen"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/nasil-dustum-bu-derde-guney-marlen.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=VjunJpLv8ZM",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/nasil-dustum-bu-derde-guney-marlen/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 3 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Bağımsız müzik sahnesinde Güney Marlen'in görsel ve müzikal dilini zenginleştiren başarılı klip prodüksiyonu.",
    "challenge": "Şarkının içsel hüznünü kentsel dokular ve sinematik ışıklandırmayla görsel bir şiire dönüştürmek.",
    "insight": "Lirik derinliği olan bağımsız müziklerde karakter odaklı sinematografi ve renk paleti izleyici etkileşimini güçlendirir.",
    "solution": "Gece çekimleri, neon ışık yansımaları ve geniş açılı lenslerle atmosferik bir görsel dünya inşa edildi.",
    "productionCraft": "4K Düşük ışık sinema çekimleri, DaVinci Resolve renk düzenlemesi.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ],
    "productionStandard": "Sinematik 4K"
  },
  {
    "id": "altinmarka-tarif-videolari",
    "slug": "altinmarka-tarif-videolari",
    "title": "Altınmarka - Dünyanın Seçkin Çikolatası İçin Gastronomik Video İçerik Serisi",
    "client": "Altınmarka",
    "year": 2024,
    "shortDescription": "Profesyonel şeflerin ve pastacılık dünyasının tercihi Altınmarka çikolataları için iştah kabartan makro çekimlerle üretilen 12 bölümlük masterclass video serisi.",
    "fullDescription": "Özel stüdyo ortamında kontrollü ısı ve ışık koşullarında makro lensler, yüksek hızlı (high-speed slow motion) kameralar ve uzman food stylist işbirliği ile 12 özel tarif filmi üretildi.",
    "categories": [
      "YouTube Projeleri",
      "Sosyal Medya"
    ],
    "services": [
      "YouTube Projeleri",
      "Sosyal Medya"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Altınmarka"
      },
      {
        "role": "Ajans",
        "name": "FUGS - Furkan Uyan Görsel Sanatlar"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Furkan Uyan"
      },
      {
        "role": "Kurgu",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/altinmarka-tarif-videolari.webp",
    "gallery": [
      "/project-covers/altinmarka-tarif-videolari-g1.webp",
      "/project-covers/altinmarka-tarif-videolari-g2.webp"
    ],
    "videoUrl": "https://www.youtube.com/watch?v=dQuJGBmcqnM",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/altinmarka-tarif-videolari/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Profesyonel şeflerin ve pastacılık dünyasının tercihi Altınmarka çikolataları için iştah kabartan makro çekimlerle üretilen 12 bölümlük masterclass video serisi.",
    "challenge": "Çikolatanın parlaklığını, akışkanlığını ve lezzet dokusunu dijital ekrandan izleyiciye hissettirecek üst düzey \"food cinematography\" standartlarını yakalamak.",
    "insight": "Gastronomi dünyasında satın alma kararı gözle başlar. Çikolatanın temperlenme anındaki ışıltı ve kırılma sesi, profesyonel şeflerin ürün kalitesini anında ayırt etmesini sağlar.",
    "solution": "Özel stüdyo ortamında kontrollü ısı ve ışık koşullarında makro lensler, yüksek hızlı (high-speed slow motion) kameralar ve uzman food stylist işbirliği ile 12 özel tarif filmi üretildi.",
    "productionCraft": "Sony FX3 + 100mm Macro Cinema Lens, 120fps High-Speed Slow-Motion ve özel gastronomi renk derecelendirmesi.",
    "metrics": [
      {
        "label": "Video Serisi",
        "value": "12 Masterclass Bölümü"
      },
      {
        "label": "Kare Hızı",
        "value": "120fps High-Speed Slow Motion"
      },
      {
        "label": "Çekim Formatı",
        "value": "4K Macro Cinema"
      },
      {
        "label": "Teslim Formatları",
        "value": "16:9 4K & 9:16 Reels"
      }
    ],
    "deliverables": [
      "12x Tarif & Masterclass Filmi",
      "24x Instagram Reels / TikTok Cutdown",
      "Yüksek Çözünürlüklü Gastronomi Fotoğraf Arşivi"
    ],
    "productionStandard": "4K 120FPS Slow-Motion"
  },
  {
    "id": "yemen-turkude-sakli-olan-efsane",
    "slug": "yemen-turkude-sakli-olan-efsane",
    "title": "Yemen: Türküde Saklı Olan Efsane - Tarihi Belgesel",
    "client": "Luys Media & TRT",
    "year": 2023,
    "shortDescription": "Tarihin derinliklerinde yankılanan Yemen Türküsü'nün ardındaki hüzünlü ve destansı hikâyeyi anlatan sinematik belgesel yapımı.",
    "fullDescription": "Müşteri: Luys Media | Prodüksiyon & Post: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nKurgu & Renk: Bora Selimoğlu, Harutyun Arto Davulciyan\n\nYemen: Türküde Saklı Olan Efsane\n\nKuşaklar boyu dilden dile aktarılan Yemen Türküsü'nün tarihsel kökenlerini, dönemin zorlu asker sevkiyatlarını ve kültürel mirasını dramatik canlandırmalar ve arşiv restorasyonlarıyla aktaran kapsamlı belgesel projesi.",
    "categories": [
      "Belgeseller"
    ],
    "services": [
      "Belgeseller"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Luys Media"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/yemen-turkude-sakli-olan-efsane.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=i0-vOobbd-c",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/yemen-turkude-sakli-olan-efsane/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Kültürel mirasımızı ve tarihi tanıklıkları gelecek nesillere aktaran derinlikli biyografik belgesel yapımı.",
    "challenge": "Yüzyıllık tarihi anlatıları arşiv fotoğrafları ve dramatik kurgu ritmiyle zenginleştirmek.",
    "insight": "Tarihi belgesellerde ses tasarımı, otantik müzik kullanımı ve titiz arşiv restorasyonu izleyicinin empati kurmasını sağlar.",
    "solution": "Tarihsel arşiv materyallerinin dijital restorasyonu ve duygusal anlatımı güçlendiren ses tasarımıyla belgesel tamamlandı.",
    "productionCraft": "Arşiv restorasyonu, 4K sinema kurgusu, tarihi ses tasarımı ve DaVinci Resolve renk düzenlemesi.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ],
    "productionStandard": "4K Belgesel Prodüksiyonu"
  },
  {
    "id": "guney-marlen-eda-baba-seni-unutmak",
    "slug": "guney-marlen-eda-baba-seni-unutmak",
    "title": "Güney Marlen & Eda Baba - Seni Unutmak Müzik Klibi",
    "client": "Güney Marlen & Eda Baba",
    "year": 2023,
    "shortDescription": "Güney Marlen ve Eda Baba'nın büyüleyici düeti 'Seni Unutmak' için hazırlanan nostaljik ve sinematik müzik klibi.",
    "fullDescription": "Sanatçılar: Güney Marlen & Eda Baba | Prodüksiyon & Post: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nKurgu & Renk: Bora Selimoğlu, Harutyun Arto Davulciyan\n\nGüney Marlen & Eda Baba: Seni Unutmak\n\nİki güçlü ve özgün vokal tonunun buluştuğu parçada, geçmişe duyulan özlem ve unutamama hissi sinematik portreler ve melankolik renk tonlarıyla görselleştirildi.",
    "categories": [
      "Video Klipler"
    ],
    "services": [
      "Video Klipler"
    ],
    "credits": [
      {
        "role": "Sanatçılar",
        "name": "Güney Marlen & Eda Baba"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/guney-marlen-eda-baba-seni-unutmak.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=aF8vjvYkrb8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/guney-marlen-eda-baba-seni-unutmak/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "İki saygın bağımsız sanatçının ortak projesini dijital platformlarda milyonlarca izlenmeye ulaştıran sinematik klip çalışması.",
    "challenge": "İki sanatçının vokal uyumunu ve parçanın hüzünlü temasını görsel bir derinlikle desteklemek.",
    "insight": "Sıcak retro tonlar ve yakın plan portre çekimleri, düet projelerinde duygusal bağı en üst seviyeye taşır.",
    "solution": "Retro renk paleti, yumuşak ışıklandırma ve sakin kamera hareketleriyle parçaya uygun bir atmosfer yaratıldı.",
    "productionCraft": "4K Sinema çekimleri, vintage lens estetiği, DaVinci Resolve renk düzenlemesi.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ],
    "productionStandard": "Sinematik 4K"
  },
  {
    "id": "endocare-renewal-serisi-reklam-filmi",
    "slug": "endocare-renewal-serisi-reklam-filmi",
    "title": "Endocare Renewal Serisi - Reklam Filmi",
    "client": "Teka Estetik",
    "year": 2024,
    "shortDescription": "Teka Estetik için reklam filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri Teka Estetik Ajans WE’24 Agency Tasarım WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Sanat Yönetmeni Aren Arda Kaya Kurgu Harutyun Arto Davulciyan\n\nWE24 Agency olarak Teka Estetik’in İstanbul, Ankara ve Antalya’da gerçekleştirdiği ‘Endocare Renewal Serisi’ lansman etkinliklerinin aftermovie’sini hazırladık. Bu video, etkinliklerin atmosferini, katılımcıların deneyimlerini ve markanın öne çıkan anlarını etkileyici bir şekilde yansıtarak unutulmaz bir lansman serisi ortaya koyuyor.\n\nDijital İletişim Ajansı",
    "categories": [
      "Reklam Filmleri"
    ],
    "services": [
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Teka Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/endocare-renewal-serisi-reklam-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=WH7HP4hh8h8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/endocare-renewal-serisi-reklam-filmi/",
    "featured": true,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Teka Estetik için reklam filmleri alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "Teka Estetik markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, Teka Estetik kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  },
  {
    "id": "garbis-zakaryan-belgeseli-luys-media",
    "slug": "garbis-zakaryan-belgeseli-luys-media",
    "title": "Garbis Zakaryan - Türkiye'nin İlk Profesyonel Milli Boksörü Belgeseli",
    "client": "Luys Media",
    "year": 2023,
    "shortDescription": "Türkiye'nin ilk profesyonel milli boksörü Garbis Zakaryan'ın hayatını anlatan, TRT Arşivine kabul edilen ve TRT Belgesel'de yayınlanan ödüllü tarihi belgesel projesi.",
    "fullDescription": "Müşteri: Luys Media | Ajans: WE24 Agency | Prodüksiyon & Post Prodüksiyon: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nSenaryo: Belinda Kuran\nKurgu Yönetmeni: Bora Selimoğlu (WE24 Agency)\nSosyal Medya: Larissa Davulciyan\nYapımcı: Harutyun Kuran | Yapım Koordinatörü: Ayk Gülezyan, Meri Kuran\nKamera Asistanı: Baret Borucuyan, Baret Tercan, Lukas Şarklı, Edgar İgityan\n\nGarbis Zakaryan: Türkiye’nin İlk Profesyonel Milli Boksörü\n\n24 yaşında Türkiye’nin ilk profesyonel milli boksörü olan Garbis Zakaryan, İstanbul ve Türkiye şampiyonluklarının ardından, 1964 yılında Ortadoğu Boks Şampiyonu oldu. Efsane boksör 22 yıllık kariyerinde 200’ü aşkın amatör, 43 uluslararası olmak üzere 100’e yakın profesyonel müsabakada yer aldı. Ay-yıldızlı formasıyla Almanya, Fransa, Arjantin, Lübnan, Mısır gibi birçok ülkede ringe çıkan Zakaryan, 1966 yılında boks kariyerine son verdi.\n\nBelgesel, Zakaryan’ın 2. Dünya Savaşı’nın zorlu şartları içerisinde boksla tanışmasına ve ardından Ortadoğu şampiyonluğuna giden ilham verici sürecine odaklanıyor. Yapım, TRT Arşivi'ne kabul edilmiş olup halen TRT Belgesel kanalında gösterilmekte ve Uluslararası TRT Belgesel Ödülleri'nde özel gösterime layık görülmüştür.",
    "categories": [
      "Belgeseller"
    ],
    "services": [
      "Belgeseller"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Luys Media"
      },
      {
        "role": "Ajans",
        "name": "WE24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Senarist",
        "name": "Belinda Kuran"
      },
      {
        "role": "Kurgu Yönetmeni",
        "name": "Bora Selimoğlu"
      },
      {
        "role": "Sosyal Medya",
        "name": "Larissa Davulciyan"
      },
      {
        "role": "Yapımcı",
        "name": "Harutyun Kuran"
      },
      {
        "role": "Yapım Koordinatörü",
        "name": "Ayk Gülezyan, Meri Kuran"
      },
      {
        "role": "Kamera Asistanı",
        "name": "Baret Borucuyan, Baret Tercan, Lukas Şarklı, Edgar İgityan"
      }
    ],
    "coverImage": "/project-covers/garbis-zakaryan-belgeseli-luys-media.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=Kmpj6kYdCWw",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/garbis-zakaryan-belgeseli-luys-media/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "TRT Arşivinde yer alan, TRT Belgesel kanalında yayını süren ve Uluslararası TRT Belgesel Ödülleri'nde özel gösterime layık görülen prestijli biyografik belgesel.",
    "challenge": "Tarihi arşiv materyallerini, nadir fotoğrafları ve tanıklıkları çağdaş sinematik anlatım diliyle restore ederek kalıcı bir ulusal kültür mirası eseri oluşturmak.",
    "insight": "Gerçek spor ve yaşam efsanelerinin mirasını aktarırken dramatik kurgu ritmi, titiz arşiv restorasyonu ve samimi tanıklıklar izleyicide derin bir tarihsel bağ kurar.",
    "solution": "WE24 Agency yönetmenliği ve sanat yönetmenliğinde, Belinda Kuran'ın senaryosu ve Bora Selimoğlu'nun kurgusuyla 4K kalitesinde restore edilmiş arşivlerle zenginleştirilen ulusal belgesel yapımı.",
    "productionCraft": "Sadece 16:9 formatında, 4K 25FPS 4:2:2 çekim, arşiv restorasyonu, DaVinci Resolve renk düzenleme ve tarihi röportaj kurgusu.",
    "metrics": [
      {
        "label": "Yayın & Arşiv",
        "value": "TRT Arşivi & TRT Belgesel"
      },
      {
        "label": "Ödül & Gösterim",
        "value": "Uluslararası TRT Ödülleri"
      },
      {
        "label": "Çekim Formatı",
        "value": "4K 25FPS 4:2:2"
      },
      {
        "label": "En Boy Oranı",
        "value": "Sadece 16:9"
      },
      {
        "label": "Tarihi Miras",
        "value": "İlk Prof. Boksörümüz"
      }
    ],
    "deliverables": [
      "4K 25FPS 16:9 Belgesel Master Film",
      "TRT Belgesel & TV Yayın Paketi",
      "Sosyal Medya Tanıtım Çıktıları",
      "Restore Edilmiş Tarihi Arşiv Görselleri"
    ],
    "productionStandard": "4K 25FPS 4:2:2 (16:9)"
  },
  {
    "id": "gelmiyorsun-ezginin-gunlugu-eda-baba",
    "slug": "gelmiyorsun-ezginin-gunlugu-eda-baba",
    "title": "Eda Baba - Gelmiyorsun (Ezginin Günlüğü) Müzik Klibi",
    "client": "Eda Baba & Ezginin Günlüğü",
    "year": 2023,
    "shortDescription": "Ezginin Günlüğü'nün kültleşen eseri 'Gelmiyorsun'un Eda Baba yorumu için hazırlanan naif, dingin ve sinematik müzik klibi.",
    "fullDescription": "Sanatçı: Eda Baba & Ezginin Günlüğü | Prodüksiyon & Post: WE’24 Agency\n\nYönetmen: Harutyun Arto Davulciyan\nSanat Yönetmeni: Aren Arda Kaya\nKurgu & Renk: Bora Selimoğlu, Harutyun Arto Davulciyan\n\nGelmiyorsun - Ezginin Günlüğü 40 Yıllık Şarkılar\n\nEzginin Günlüğü'nün 40. sanat yılına özel hazırlanan saygı albümünde yer alan 'Gelmiyorsun' şarkısının Eda Baba yorumu, geçmişin melodik hüznünü modern sinematik görsellikle buluşturmaktadır.",
    "categories": [
      "Video Klipler"
    ],
    "services": [
      "Video Klipler"
    ],
    "credits": [
      {
        "role": "Sanatçı",
        "name": "Eda Baba"
      },
      {
        "role": "Müzik",
        "name": "Ezginin Günlüğü"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/gelmiyorsun-ezginin-gunlugu-eda-baba.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=QtsTO4lFGIc",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/gelmiyorsun-ezginin-gunlugu-eda-baba/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 3 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Türk müzik tarihinin en değerli gruplarından Ezginin Günlüğü'nün 40. yıl saygı albümünde öne çıkan prestijli video yapımı.",
    "challenge": "40 yıllık bir müzik klasiğine modern sinematografiyle saygılı ve taze bir görsel dil kazandırmak.",
    "insight": "Kült şarkıların yeniden yorumlarında nostaljik doku ve modern görsel kalite dengesi dinleyici sadakatini artırır.",
    "solution": "Dingin iç mekan kompozisyonları, yumuşak pencere ışıkları ve sinematik renk derecelendirmesiyle şarkının ruhu yansıtıldı.",
    "productionCraft": "4K 25FPS 4:2:2 çekimler, DaVinci Resolve renk düzenlemesi, minimalist görsel dil.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ],
    "productionStandard": "4K Sinema Formatı"
  },
  {
    "id": "sergen-ile-10-numara-muhabbet-turkcell-bip",
    "slug": "sergen-ile-10-numara-muhabbet-turkcell-bip",
    "title": "Sergen ile 10 Numara Muhabbet - Turkcell BiP",
    "client": "4Play & Turkcell BiP",
    "year": 2023,
    "shortDescription": "4Play & Turkcell BiP için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "fullDescription": "Müşteri 4Play & Turkcell BiP Ajans CYemen Film Yapım I YFY Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Artun Sağbazar Kurgu Bora Selimoğlu\n\nTurkcell BiP: Yerli Teknolojilerle Geliştirilen Güvenli İletişim Platformu\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "4Play & Turkcell BiP"
      },
      {
        "role": "Ajans",
        "name": "Yemen Film Yapım I YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/sergen-ile-10-numara-muhabbet-turkcell-bip.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=4eACV2hwOJA",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/sergen-ile-10-numara-muhabbet-turkcell-bip/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 2 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "4Play & Turkcell BiP için video prodüksiyon alanında marka algısını güçlendiren ve hedef kitleyle derin bağ kuran sinematik proje.",
    "challenge": "4Play & Turkcell BiP markasının iletişim hedeflerini modern görsel anlatım diliyle buluşturmak ve sektördeki rekabet gücünü artırmak.",
    "insight": "İzleyicinin dikkat süresinin kısaldığı dijital çağda, ilk 3 saniyeden itibaren güçlü bir görsel ritim ve duygusal bir kanca oluşturmak başarının anahtarıdır.",
    "solution": "WE24 Agency olarak, 4Play & Turkcell BiP kimliğine özel konsept geliştirerek yüksek çözünürlüklü sinema ekipmanları ve profesyonel post-prodüksiyon süreçleriyle projeyi hayata geçirdik.",
    "productionCraft": "4K/6K Sinema kameraları, profesyonel aydınlatma tasarımı, DaVinci Resolve renk düzenlemesi ve dinamik ses miksajı.",
    "metrics": [
      {
        "label": "Görüntü Kalitesi",
        "value": "4K Ultra HD"
      },
      {
        "label": "Prodüksiyon Standardı",
        "value": "Sinema Formatı"
      },
      {
        "label": "Teslimat Formatları",
        "value": "16:9 & 9:16 Sosyal Medya"
      }
    ],
    "deliverables": [
      "4K Master Film",
      "Sosyal Medya Video Kesitleri",
      "Yüksek Çözünürlüklü Görseller"
    ]
  }
];
